import httpClient from "@plugins/http";
import { ApiResponse } from "@apis/api.ts";
import { OwnerGroupMentionRecipientModel } from "@modules/attempt/types.ts";

const fetchOwnerGroup = () => {
  return httpClient.get(`/apis/ownergroup`);
};
const fetchAllOwnerGroup = () => {
  return httpClient.get(`/apis/ownergroup/all`);
};

const fetchOwnViewMentionRecipients = (params: {
  lessonUuid?: string;
  ownerGroupId?: number;
}): Promise<ApiResponse<OwnerGroupMentionRecipientModel[]>> => {
  return httpClient.get(`/apis/ownergroup/mention-recipients`, {
    params,
  });
};

export default {
  fetchOwnerGroup,
  fetchAllOwnerGroup,
  fetchOwnViewMentionRecipients,
};
